import { createContext } from "react";
import { USE_STATE_T } from "../constants/objectTye";

type elType = {
    formNumber: number | null, setformNumber: USE_STATE_T,
    isDemandeOptionZone: boolean, setisDemandeOptionZone: USE_STATE_T
}

export const FormNumberContext = createContext({} as elType);
